module.exports = __webpack_public_path__ + "static/media/bolt.050e28f3.svg";